export const environment = {
  ENV: 'dit',
  APP: 'asm-external',
  THEME: 'asm-light',
  ASM_API_URL: 'https://asm-backend.ditext.outpost24.com',
  HTTP_MOCKS: [],
};
